var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2832",
    "data-name": "Rectangle 2832",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13238",
    "data-name": "Group 13238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13238-2",
    "data-name": "Group 13238",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13012",
    "data-name": "Path 13012",
    d: "M18.138,10.412V9.573l1.286-1.092a1.63,1.63,0,0,0,.327-2.108L18.059,3.587a1.7,1.7,0,0,0-1.448-.818H16.6a1.675,1.675,0,0,0-.542.083l-1.627.534a8.268,8.268,0,0,0-.75-.417l-.34-1.637A1.682,1.682,0,0,0,11.66,0H8.312A1.7,1.7,0,0,0,6.621,1.328L6.28,2.963c-.258.127-.509.266-.753.417L3.913,2.814a1.656,1.656,0,0,0-.52-.045H3.388a1.7,1.7,0,0,0-1.453.82L.241,6.378A1.618,1.618,0,0,0,.583,8.455L1.852,9.586v.84L.59,11.515a1.632,1.632,0,0,0-.349,2.11l1.692,2.791a1.7,1.7,0,0,0,1.446.821h.01a1.984,1.984,0,0,0,.542-.083l1.629-.536a8.5,8.5,0,0,0,.75.418l.341,1.636A1.679,1.679,0,0,0,8.286,20h3.475A1.682,1.682,0,0,0,13.4,18.671l.34-1.634a8.382,8.382,0,0,0,.756-.418l1.621.535a1.743,1.743,0,0,0,.526.083.048.048,0,0,1,.017,0,1.708,1.708,0,0,0,1.456-.825l1.631-2.789a1.619,1.619,0,0,0-.341-2.077Zm-14.213.8L3.9,11.07a5.75,5.75,0,0,1,0-2.092l.027-.142-1.9-1.677L3.506,4.723l2.4.79.108-.09A6.115,6.115,0,0,1,7.88,4.371l.137-.048.5-2.443H11.48l.5,2.413.134.049A6.474,6.474,0,0,1,13.971,5.4l.107.086,2.406-.761L17.96,7.157l-1.9,1.629.027.145a5.75,5.75,0,0,1,0,2.092l-.027.142,1.9,1.677-1.475,2.435-2.4-.791-.109.089a6.113,6.113,0,0,1-1.865,1.052l-.137.048-.5,2.444H8.513l-.5-2.413-.133-.049A6.5,6.5,0,0,1,6.021,14.6l-.107-.086-2.406.761L2.029,12.846Z",
    transform: "translate(0 0)",
    fill: "#0083bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13013",
    "data-name": "Path 13013",
    d: "M9.869,14.276A4.535,4.535,0,0,0,13.074,13a4.3,4.3,0,0,0,1.309-3.121,4.4,4.4,0,1,0-4.515,4.4M7.721,7.788A2.983,2.983,0,0,1,9.869,6.95v0a2.936,2.936,0,0,1,2.148,5.027,3.171,3.171,0,0,1-4.3,0,2.973,2.973,0,0,1,0-4.184",
    transform: "translate(0.128 0.125)",
    fill: "#0083bf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a476a16f15631c26ddc0f5cb3598d258.svg";
export { ForwardRef as ReactComponent };